let revision = 0;
let controller = new AbortController();
const listeners = new Set<(owner: object) => void>();

export function sessionRevision(): number {
  return revision;
}

export function sessionSignal(): AbortSignal {
  return controller.signal;
}

export function subscribeToSession(listener: (owner: object) => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function assertCurrentSession(expected: number | undefined): void {
  if (expected !== revision) {
    throw new DOMException("The account or business changed. Please try again.", "AbortError");
  }
}

export function replaceSessionRequestScope(): void {
  revision += 1;
  controller.abort();
  controller = new AbortController();
}

export function notifySessionChange(owner: object): void {
  for (const listener of listeners) listener(owner);
}
